import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, role, context }) => {
    const { user, appContext } = useSelector((state) => state.user || {});
    const token = localStorage.getItem('access_token'); // Check storage directly
    const location = useLocation();

    // 1. If no token, they must login
    if (!token || !user) {
        const loginPath = context === 'classroom' ? '/classroom-login' : '/login';
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }

    // 2. If they are in the wrong portal (e.g. Studio user trying Classroom URL)
    if (context && appContext !== context) {
        return <Navigate to="/" replace />; // Let RootRedirect decide the correct home
    }

    // 3. Admin-only check
    if (role === 'tenant_admin' && user.role !== 'tenant_admin' && user.role !== 'system_admin') {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;